module.exports = __webpack_public_path__ + "img/img_supplier_jy@2x.53d1b595.png";